import { environment } from "../../../../environments/environment";

export const common = {
  area: "b2c",
  segment: "ecommerce",
  category: "vale-saude",
  environment: "web",
  platform: `web:${environment.version}`,
};
